export const CONDITION_GROUP_SPECIAL_ID_PRIVATE = '02';
export const CONDITION_GROUP_SPECIAL_ID_STORM = 'ST';
export const CONDITION_GROUP_SPECIAL_ID_WOLF_STORM = 'WS';
export const CONDITION_GROUP_SPECIAL_DESC_PATTERN = /(?:storm|private)/i;
